import * as yup from 'yup'

const ResetPasswordValidator = yup.object({
    new_password: yup.string().required('Password is required'),
    confirm_new_password: yup.string()
       .oneOf([yup.ref('new_password'), null], 'Passwords must match')
  });
   

export { ResetPasswordValidator }